import React, { Component } from 'react';
import { connect } from 'react-redux';

import '../../../scss/components/pages/home.scss';
import logoGolden from '../../../images/logo__Store.svg';
import mainCup from '../../../images/cup-main.svg';
import subCup from '../../../images/cup-sub.svg';
import backgroundImage from '../../../images/loginback.png';
import {
  updateStore
} from '../../../store/action';
class Store extends Component {
  componentWillMount(){
    let { history,updateStore } = this.props;

    function checkInput(){
      if (!localStorage.getItem('current_store_id')){
        localStorage.setItem('current_store_id',1)
        updateStore();
        history.push('/');
      }
    }
    localStorage.removeItem('current_store_id');
    updateStore();

    window.onpopstate = function(event) {
      checkInput();   
    }
  }



  render() {
    let { history,updateStore } = this.props;

    function handleClick(e) {
        e.preventDefault();
        localStorage.setItem('current_store_id',e.target.id)
        updateStore();
        history.push('/~');
    }
    var userStore =  localStorage.getItem('all_store_id');

    

    return (
    <div className="cup-wraper" style={{backgroundImage: `url(${backgroundImage})`}}>
      <img src={logoGolden} alt="logoGolden" />
      <br/>
      <div className="cup-container"> 
        <div className="row">
          {
            userStore.indexOf('1') !== -1?(
              <div className="col-md-6" style={{paddingLeft:'45px'}}>
            <img src={mainCup} alt="mainCup"  id="1" onClick={handleClick}/>
            <h1 className="cup-title" id="1" onClick={handleClick} style={{left: '3px'}}>板橋店</h1>
            </div>):''
          }
          {
            userStore.indexOf('3') !== -1?(
              <div className="col-md-6" style={{paddingLeft:'40px'}}>
              <img src={subCup} alt="subCup"  id="3" onClick={handleClick}/>
              <h1 className="cup-title" id="3" onClick={handleClick} style={{left: '25px'}}>北大店</h1>
              </div>):''
          }
                    {
            userStore.indexOf('2') !== -1?(
              
            <div className="col-md-6" style={{paddingLeft:'40px'}}>
            <img src={subCup} alt="subCup"  id="2" onClick={handleClick}/>
            <h1 className="cup-title" id="2" onClick={handleClick} style={{left: '25px'}}>海大店</h1>
            </div>
):''
          }


        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = (store) => ({
  
})
export default connect(mapStateToProps,{
  updateStore
})(Store)
